import { Modal, ModalBody, ModalHeader, VFlow } from 'bold-ui'
import { LoadingIndicator } from 'components/loading'
import { formatHoursMinutes } from 'util/date/formatDate'

import { HistoricoPlanoCuidadoListItem } from './components/HistoricoPlanoCuidadoListItem'
import { PlanoCuidadoLotacaoModel, PlanoCuidadoModel } from './model'

interface HistoricoPlanoCuidadoModalProps {
  planosDeCuidado: ReadonlyArray<PlanoCuidadoModel>
  atendProfIniciador: PlanoCuidadoLotacaoModel
  loading: boolean
  onClose(): void
}

const modalTitle = 'Visualizar planos de cuidado'

export const HistoricoPlanoCuidadoModal = (props: HistoricoPlanoCuidadoModalProps) => {
  const { planosDeCuidado, atendProfIniciador, loading, onClose } = props

  return (
    <Modal open onClose={onClose}>
      <ModalHeader
        title={modalTitle}
        subtitle={
          !loading &&
          `Observação iniciada pelo profissional ${
            atendProfIniciador?.lotacao.profissional.nome
          } às ${formatHoursMinutes(atendProfIniciador?.iniciadoEm)}`
        }
      />
      <ModalBody>
        {loading ? (
          <LoadingIndicator />
        ) : (
          <VFlow vSpacing={0.5}>
            {planosDeCuidado?.map((planoDeCuidado) => (
              <HistoricoPlanoCuidadoListItem key={planoDeCuidado.id} planoDeCuidado={planoDeCuidado} />
            ))}
          </VFlow>
        )}
      </ModalBody>
    </Modal>
  )
}
